import { render, staticRenderFns } from "./ClientBaseModal.vue?vue&type=template&id=0e954574&"
import script from "./ClientBaseModal.vue?vue&type=script&lang=js&"
export * from "./ClientBaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports